<template>
    <div class="page_bg">
        <div class="main_box">
            <!-- 顶部导航栏 -->
            <div class="back_box">
                <div class="back_left">
                    <div class="back_btn" @click="backPage">
                        <i class="el-icon-arrow-left"></i>
                        <span>返回</span>
                    </div>
                    <div class="page_title">
                        <span class="class_name">{{ className }}</span>
                        <span class="title_sep">/</span>
                        成绩查询
                    </div>
                </div>
            </div>
            <!-- Tab 切换 -->
            <div class="tab_bar">
                <div class="tab_item" :class="{ tab_active: pageTabIndex == index }"
                    v-for="(item, index) in examType" :key="index" @click="changePaegIndex(index)">{{ item }}</div>
            </div>
            <!-- 列表区域 -->
            <div class="list_box" v-if="pageTabIndex == 0" @scroll="TKhandleScroll">
                <div class="list_item" v-for="(item, index) in MKListData" :key="index">
                    <div class="col_1">{{ item.sub_name }}</div>
                    <div class="col_2"><span class="score_num">{{ item.score }}</span>分</div>
                    <div class="col_3">{{ item.time | dateFormat }}</div>
                    <div class="col_4">{{ item.duration }}分钟</div>
                    <div class="col_5">
                        <div class="action_btn" @click="loogWrong(0, index)">查看错题</div>
                        <div class="action_btn action_btn_primary" @click="loogAll(0, index)">查看全卷</div>
                    </div>
                </div>
                <div class="empty_tip" v-if="MKListData.length === 0">暂无数据</div>
            </div>
            <div class="list_box" v-if="pageTabIndex == 1" @scroll="TKhandleScroll">
                <div class="list_item" v-for="(item, index) in TKListData" :key="index">
                    <div class="col_1">{{ item.title }}</div>
                    <div class="col_2"><span class="score_num">{{ item.score }}</span>分</div>
                    <div class="col_3">{{ item.start_time | dateFormat }}</div>
                    <div class="col_4">{{ item.duration }}分钟</div>
                    <div class="col_5">
                        <div v-if="item.ques_show" class="action_btn" @click="loogWrong(1, index)">查看错题</div>
                        <div v-if="item.ques_show" class="action_btn action_btn_primary" @click="loogAll(1, index)">查看全卷</div>
                    </div>
                </div>
                <div class="empty_tip" v-if="TKListData.length === 0">暂无数据</div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { _getMKResultList, _getTKResultList } from "../../api/lookSubject"
export default {
    components: { },
    created() {
        this.getMKList()
        this.getTKList()
        this.className = window.localStorage.getItem("className") || ""
    },

    destroyed() {

    },

    mounted() {
        this.pageTabIndex = window.localStorage.getItem("lookIndex")
    },
    data() {
        return {
            className: "",
            pageTabIndex: 0,
            examType: ["模考成绩", "统考成绩"],
            MKListData: [],
            MKDataLength: 0,
            MKPageNumber: 1,

            TKListData: [],
            TKDataLength: 0,
            TKPageNumber: 1,


        };
    },
    methods: {
        backPage() {
            this.$router.push({ name: 'ExamTab' })
        },
        TKhandleScroll(event) {
            const dialog = event.target;
            if (dialog.scrollHeight - dialog.scrollTop === dialog.clientHeight) {
                console.log("滚动到底了");
                if (this.MKListData.length >= this.MKDataLength) {
                    console.log("数据没了");
                    return false
                }
                this.MKPageNumber = this.MKPageNumber + 1
                this.getMKList()
            }

        },
        async getMKList() {
            let params = {
                pro_id: window.localStorage.getItem("proID"),
                page: this.MKPageNumber,
                load:true
            }
            let res = await _getMKResultList(params)
            console.log("模考成绩列表");
            console.log(res.data.data);
            if (this.MKPageNumber == 1) {

                this.MKListData = res.data.data
                this.MKDataLength = res.data.total
            } else {
                this.MKListData = this.MKListData.concat(res.data.data)
                this.MKDataLength = res.data.total
            }
        },
        TKhandleScroll(event) {
            const dialog = event.target;
            if (dialog.scrollHeight - dialog.scrollTop === dialog.clientHeight) {
                console.log("滚动到底了");
                if (this.TKListData.length >= this.TKDataLength) {
                    console.log("数据没了");
                    return false
                }
                this.TKPageNumber = this.TKPageNumber + 1
                this.getTKList()
            }
        },
        async getTKList() {
            let params = {
                pro_id: window.localStorage.getItem("proID"),
                page: this.TKPageNumber,
                load:true
            }
            let res = await _getTKResultList(params)
            console.log("统考成绩列表");
            console.log(res.data.data);
            if (this.TKPageNumber == 1) {
                this.TKListData = res.data.data
                this.TKDataLength = res.data.total
            } else {
                this.TKListData = this.TKListData.concat(res.data.data)
                this.TKDataLength = res.data.total
            }
        },
        changePaegIndex(index) {
            this.pageTabIndex = parseInt(index)
            window.localStorage.setItem("lookIndex", this.pageTabIndex)

            switch (this.pageTabIndex) {
                case 0:
                    this.MKListData = []
                    this.MKDataLength = 0
                    this.MKPageNumber = 1
                    this.getMKList()
                    break;
                case 1:
                    this.TKListData = []
                    this.TKDataLength = 0
                    this.TKPageNumber = 1
                    this.getTKList()
                    break;
                default:
                    break;
            }
        },
        loogWrong(tabIndex, index) {
            switch (parseInt(tabIndex)) {
                case 0:
                    window.localStorage.setItem("lookObjectExamID", this.MKListData[index].id)
                    break;
                case 1:
                    window.localStorage.setItem("lookObjectExamID", this.TKListData[index].id)
                    break;
                default:
                    break;
            }
            this.$router.push({ name: 'LookWrong' })
        },
        loogAll(tabIndex, index) {
            switch (parseInt(tabIndex)) {
                case 0:
                    window.localStorage.setItem("lookObjectExamID", this.MKListData[index].id)
                    break;
                case 1:
                    window.localStorage.setItem("lookObjectExamID", this.TKListData[index].id)
                    break;
                default:
                    break;
            }
            this.$router.push({ name: 'LookAll', })
        },
    },
};
</script>
<style scoped>
/* 页面背景 */
.page_bg {
    background: #f5f7fa;
    width: 100%;
    min-height: 100vh;
    overflow-y: auto;
}

.main_box {
    width: 1160px;
    margin: 0 auto;
    padding-bottom: 60px;
}

/* 顶部导航栏 */
.back_box {
    width: 100%;
    max-width: 1160px;
    height: 56px;
    background: #fff;
    margin: 20px auto 18px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 24px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.back_left {
    display: flex;
    align-items: center;
    gap: 18px;
}

.back_btn {
    height: 34px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    background: #f0f2ff;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    color: #646eff;
    font-weight: 500;
    transition: all 0.2s;
}

.back_btn:hover {
    background: #e4e7ff;
}

.back_btn i {
    font-size: 13px;
}

.page_title {
    color: #1a1a2e;
    font-weight: 700;
    font-size: 18px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.class_name {
    color: #646eff;
    font-weight: 600;
}

.title_sep {
    color: #dcdfe6;
    font-weight: 400;
}

/* Tab 切换栏 */
.tab_bar {
    width: 100%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    padding: 6px 8px;
    box-sizing: border-box;
    margin-bottom: 16px;
    display: flex;
    gap: 8px;
}

.tab_item {
    height: 38px;
    padding: 0 24px;
    line-height: 38px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #606266;
    background: #f7f8fa;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid transparent;
}

.tab_item:hover {
    background: #eef0ff;
    color: #646eff;
}

.tab_active {
    background: #646eff !important;
    color: #fff !important;
    box-shadow: 0 2px 8px rgba(100, 110, 255, 0.25);
}

/* 列表区域 */
.list_box {
    width: 100%;
    background: #fff;
    border-radius: 10px;
    border: 1px solid #eef0f5;
    overflow-y: auto;
    max-height: calc(100vh - 200px);
}

.list_item {
    width: 100%;
    box-sizing: border-box;
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f0f2f5;
    transition: all 0.2s;
}

.list_item:hover {
    background: #fafbff;
}

.list_box .list_item:last-child {
    border-bottom: none;
}

.list_item > div {
    display: flex;
    align-items: center;
    justify-content: center;
}

.list_item .col_1 {
    width: 320px;
    color: #1a1a2e;
    font-weight: 600;
    font-size: 16px;
    justify-content: flex-start !important;
}

.list_item .col_2 {
    flex: 1;
    color: #eb4034;
    font-weight: 600;
    font-size: 15px;
}

.score_num {
    font-size: 22px;
    font-weight: 700;
    margin-right: 2px;
}

.list_item .col_3,
.list_item .col_4 {
    flex: 1;
    color: #909399;
    font-weight: 400;
    font-size: 13px;
}

.list_item .col_5 {
    width: 240px;
    height: 36px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

/* 操作按钮 */
.action_btn {
    height: 32px;
    padding: 0 16px;
    line-height: 32px;
    font-size: 13px;
    font-weight: 500;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
    background: #f7f8fa;
    color: #606266;
    border: 1px solid #ebeef5;
}

.action_btn:hover {
    background: #eef0ff;
    color: #646eff;
    border-color: rgba(100, 110, 255, 0.2);
}

.action_btn_primary {
    background: linear-gradient(135deg, #646eff, #7b83ff);
    color: #fff;
    border: none;
    box-shadow: 0 2px 8px rgba(100, 110, 255, 0.2);
}

.action_btn_primary:hover {
    color: #fff;
    box-shadow: 0 3px 12px rgba(100, 110, 255, 0.35);
    transform: translateY(-1px);
}

/* 空状态提示 */
.empty_tip {
    width: 100%;
    padding: 60px 0;
    text-align: center;
    color: #c0c4cc;
    font-size: 14px;
}
</style>